import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Helmet } from "react-helmet";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Tags from "../../components/Tags/Tags";
import Preloader from "../../components/Preloader/Preloader";
import { Config } from "../../Config";
import "./OtherPages.scss";
import "./Responsive.scss";
import Skeleton from "react-loading-skeleton";

const OtherPages = (props) => {
  // const pageId = props.match.params.id && props.match.params.id;
  let pageId;
  if (props.location.state === undefined) {
    props.history.push("/404");
  } else {
    pageId = props.location.state.pageId;
  }
  const [pages, setPages] = useState({});
  const [preloader, setPreloader] = useState(false);
  const user = useSelector((state) => state.user);
  const breadCrumbData = [
    { title: "خانه", link: "/" },
    { title: pages && pages.title, link: `/pages/${pageId}` },
  ];

  useEffect(() => {
    Config.pageUp();
    getPageInfo();
  }, [props.location.state.pageId && props.location.state.pageId]);

  const getPageInfo = () => {
    setPreloader(true);
    axios
      .get(
        `/Pages/Index/${pageId}`,
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        console.log(result);
        setPages(result.data);
        setPreloader(false);
      })
      .catch((error) => {
        setPreloader(false);
        // console.log(error);
      });
  };

  return (
    <section className="otherPagesWrapper">
      {/* {preloader && <Preloader active={preloader} />} */}
      <Helmet>
        {/* <title>ایران رگالو | {`${pages?.pageTitle}`}</title> */}
        <title>
          {Config.helmetTitle} | {`${pages?.pageTitle}`}
        </title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <BreadCrumb breadCrumbData={breadCrumbData} />
      {!pages || !pages.image ? (
        <Skeleton
          highlightColor={Config.skeletonHighlightColor}
          containerClassName="headerBackground"
          className="skeleton"
        />
      ) : (
        <div className="headerBackground">
          <img src={pages && pages.image} alt={pages && pages.pageTitle} />
        </div>
      )}
      <div className="contentWrapper">
        <div className="desktop">
          <div className="minHeader">
            <span className="minHeaderItem">{pages && pages.dateTime}</span>
          </div>
          <div className="pageContent">
            <p className="contentTitle">{pages && pages.pageTitle}</p>
            {!pages || !pages.description ? (
              <>
                <Skeleton
                  containerClassName="contentDetails"
                  className="skeleton"
                  highlightColor={Config.skeletonHighlightColor}
                  count={5}
                />
                <Skeleton
                  containerClassName="contentDetails"
                  className="skeleton"
                  width="50%"
                  highlightColor={Config.skeletonHighlightColor}
                />
              </>
            ) : (
              <div className="contentDetails" dangerouslySetInnerHTML={{ __html: pages && pages.description }} />
            )}
          </div>
          <Tags tagData={pages.tags !== undefined && pages.tags !== " " ? pages.tags : []} />
        </div>
      </div>
    </section>
  );
};

export default React.memo(OtherPages);
